import React from 'react';

import Paragraph from './ui/Typography/Paragraph';
import Headline from './ui/Typography/Headline';
import ChatPlaceholder from './Layout/Chat/ChatPlaceholder';
import { $l } from '../locales';

export const BanPage = () => (
  <ChatPlaceholder>
    <Headline>{$l('CHAT_ACCESS_BLOCKED')}</Headline>
    <Paragraph>{$l('BLOCK_TEXT')}</Paragraph>
  </ChatPlaceholder>
);
export default BanPage;
